<script>
    import { redirect, goto } from '@roxi/routify'

    $redirect('/area_privada')
  </script>